import React from 'react'
import SEO from '../components/SEO'
import { StaticImage } from 'gatsby-plugin-image'
import Spotify from '../components/Spotify'

const AboutPage = () => {
	return (
		<>
			<SEO title='About' description="My name is Michał Kotowski. I am an aspiring music producer, a graphic designer, but most of all - a developer."/>
			<div className='section'>
				<StaticImage src='../assets/images/michal-kotowski-about.jpg' alt='Michał Kotowski' quality={100} layout="fixed" height={207} className='hero-image'/>
				<h1>Hello, World!</h1>
				<p>
					My name is Michal Kotowski. I am an aspiring music producer, a graphic designer, but most of all - a developer. 
					I love being among nature, riding a bike and broadening my competences across all topics.
					I'm all about minimalism, mindfulness and self development. Based in Warsaw.
				</p>
				<p>
					I would like to thank creators of lofi hip hop without whom I would not be able to concentrate and accomplish all things I have achieved.
				</p>
			</div>
			<Spotify/>
		</>
	)
}

export default AboutPage